import { ROUTE_PAGE_ACCOUNT } from '@components/Router/constants'
import type { Location } from 'history'
import type { Action } from 'redux'
import { call } from 'redux-saga/effects'

import { loadEmails } from './loadEmails'

// redux-first-history's LOCATION_CHANGE; the package does not export its type
interface LocationChange extends Action {
  payload: { location: Location }
}

// The choices are read when the account page is entered, not when its
// section mounts
export function* loadEmailsOnAccount({ payload }: LocationChange) {
  if (payload.location.pathname.replace(/\/$/, '') !== ROUTE_PAGE_ACCOUNT) {
    return
  }

  yield call(loadEmails)
}
